var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-faq__accordion--item" }, [
    _c(
      "button",
      {
        attrs: {
          "aria-controls": _vm.elementId,
          "aria-expanded": _vm.isOpen ? "true" : "false"
        },
        on: { click: _vm.onToggle }
      },
      [
        _c("span", [_vm._v(_vm._s(_vm.item.question))]),
        _vm._v(" "),
        _c(
          "span",
          [
            _c("v-icon", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isOpen,
                  expression: "!isOpen"
                }
              ],
              attrs: { name: "icon-plus" }
            }),
            _vm._v(" "),
            _c("v-icon", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpen,
                  expression: "isOpen"
                }
              ],
              attrs: { name: "icon-minus" }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "article",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpen,
            expression: "isOpen"
          }
        ],
        attrs: { id: _vm.elementId }
      },
      [
        _c("div", {
          staticClass: "c-faq-accordion--answer",
          domProps: { innerHTML: _vm._s(_vm.item.answer) }
        }),
        _vm._v(" "),
        _vm.item.youTubeLink
          ? _c(
              "div",
              { staticClass: "c-faq-accordion--youtube" },
              [
                _c("you-tube-player", {
                  attrs: { url: _vm.item.youTubeLink, title: _vm.item.linkText }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.item.link
          ? _c("div", { staticClass: "c-faq__accordion--articlelink" }, [
              _c("a", { attrs: { href: _vm.item.link } }, [
                _c("span", [_vm._v(_vm._s(_vm.item.linkText))]),
                _vm._v(" "),
                _c(
                  "span",
                  [_c("v-icon", { attrs: { name: "icon-chevron" } })],
                  1
                )
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }